import 'onsenui/css/onsenui.css'; // Onsen UI basic CSS
import 'onsenui/css/onsen-css-components.css'; // Default Onsen UI CSS components
import './assets/css/onsen-override.css';
import './assets/css/style.css';
import 'swiper/dist/css/swiper.css';

import Vue from 'vue';
import Vuex from 'vuex';
import VueOnsen from 'vue-onsenui'; // For UMD
import moment from 'vue-moment';
import storeLike from './stores/index.js';
import AppNavigator from './components/app_navigator.vue';

Vue.use(Vuex);
Vue.use(VueOnsen);
Vue.use(moment);

const d3 = require('../node_modules/d3/dist/d3.js');
window.d3 = d3;

const taiseiSignage = new Vue({
  beforeCreate() {
    // Set iPhoneX flag based on URL
    if (window.location.search.match(/iphonex/i)) {
      document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
      document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
    }
  },
  render: (h) => h(AppNavigator),
  store: new Vuex.Store(storeLike),
  created() {
    this.$store.commit('appNavigator/getWindowRect');

    window.addEventListener('resize', () => {
      this.$store.commit('appNavigator/getWindowRect');
    }, { passive: false });
  },
});

taiseiSignage.$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js